const CREATE_TOAST = 'CREATE_TOAST';
const REMOVE_TOAST_BY_ID = 'REMOVE_TOAST_BY_ID';

export {
    CREATE_TOAST,
    REMOVE_TOAST_BY_ID
};
